import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

function TabButton({ icon, label, target }) {
  const { pathname } = useRouter();
  const { t } = useTranslation("dashboard");
  const active =
    target.split("/")[target.split("/").length - 1] ===
    pathname.split("/")[pathname.split("/").length - 1];

  return (
    <Link
      className="relative flex items-center text-base cursor-pointer md:flex-col md:mt-10 max-sm:min-w-32"
      href={target}
    >
      <span
        className={`px-2 h-10 md:w-64 md:h-12 
        ${active ? "bg-white text-black" : "bg-primary  text-white"} 
        flex flex-row-reverse justify-center items-center gap-2
        ${
          active ? "border-2 border-black" : "border"
        } rounded-md max-sm:w-full max-sm:text-xs`}
      >
        {t(label)}
        <span
          className={`flex items-center justify-center size-5 ${
            active ? "border-black bg-white" : ""
          }`}
        >
          {icon}
        </span>
      </span>
    </Link>
  );
}

export default TabButton;
